module.exports = __webpack_public_path__ + "img/silver_logo.c7209a1b.svg";